import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ChatbotliveService {
  apiAddress: string = environment.apiAddress;

  private selectedCustomerData = new BehaviorSubject<any>(null);
  customerData$ = this.selectedCustomerData.asObservable();

  constructor(private http: HttpClient) {}

  takeControl(botId: string, payload: { correlation_id: string; take_manual_control: boolean }) {
    return this.http.post<{ response: string }>(
      `${this.apiAddress}/bot/${botId}/chat/take-control`,
      payload
    );
  }

  updateChatHeader(botId: string, correlation_id: string) {
    return this.http.put<any>(`${this.apiAddress}/bot/${botId}/chat/update`, {
      new_message: false,
      correlation_id,
    });
  }

  sendAnswer(botId: string, correlation_id: string, answer: string) {
    return this.http.post<any>(`${this.apiAddress}/bot/${botId}/chat/answer`, {
      correlation_id,
      answer,
    });
  }

  // Nuevo método para actualizar los datos del cliente
  updateCustomerData(data: any) {
    this.selectedCustomerData.next({
      created_at: data.created_at,
      channel: data.channel,
      name: data.name,
      phone: data.phone,
      email: data.email,
      sender_requirement: data.sender_requirement,
      correlation_id: data.correlation_id,
    });
  }
  updateCustomerField(botId: string, correlation_id: string, fields: any) {
    const payload = {
      correlation_id,
      ...fields,
      new_message: false,
    };
    return this.http.put<any>(`${this.apiAddress}/bot/${botId}/chat/update`, payload);
  }
  setAiResponseDelay(botId: string, timeInMinutes: number) {
    return this.http.put<any>(`${this.apiAddress}/bot/${botId}/ai_response_delay`, {
      time_in_minutes: timeInMinutes,
    });
  }
}
